export default __webpack_public_path__ + "static/media/swim.95898e1c.svg";